import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _isNativeReflectConstruct from "@babel/runtime/helpers/isNativeReflectConstruct";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["country", "phone", "onChange", "onBlur", "onFocus", "disabled", "readonly", "autofocus", "placeholder"],
  _excluded2 = ["value", "formContext", "registry", "rawErrors"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import React, { Component } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var COUNTRY_OPTIONS = ["49", "43"];
var CountrySelect = function CountrySelect(_ref) {
  var value = _ref.value,
    onSelect = _ref.onSelect,
    disabled = _ref.disabled;
  return /*#__PURE__*/_jsx("select", {
    className: "mibabySelect form-control",
    disabled: disabled,
    value: value,
    onChange: function onChange(e) {
      return onSelect(e.target.value);
    },
    children: COUNTRY_OPTIONS.map(function (n) {
      return /*#__PURE__*/_jsx("option", {
        value: n,
        children: "+".concat(n)
      }, n);
    })
  });
};
var PhoneControl = function PhoneControl(_ref2) {
  var country = _ref2.country,
    phone = _ref2.phone,
    _onChange = _ref2.onChange,
    onBlur = _ref2.onBlur,
    onFocus = _ref2.onFocus,
    disabled = _ref2.disabled,
    readonly = _ref2.readonly,
    autofocus = _ref2.autofocus,
    placeholder = _ref2.placeholder,
    inputProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    className: "row",
    children: [/*#__PURE__*/_jsx("div", {
      className: "col-xs-4 col-sm-2",
      children: /*#__PURE__*/_jsx(CountrySelect, {
        value: country,
        disabled: disabled,
        onSelect: function onSelect(c) {
          return _onChange(c, phone);
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "col-xs-8 col-sm-10",
      children: /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
        className: "form-control",
        readOnly: readonly,
        disabled: disabled,
        autoFocus: autofocus,
        placeholder: placeholder,
        value: phone == null ? "" : phone
      }, inputProps), {}, {
        onChange: function onChange(e) {
          return _onChange(country, e.target.value);
        }
      }))
    })]
  });
};
var splitValue = function splitValue(value) {
  return (value = value.toString()) && [value.slice(0, 2), value.slice(2)];
};
var _default = /*#__PURE__*/function (_Component) {
  function _default() {
    _classCallCheck(this, _default);
    return _callSuper(this, _default, arguments);
  }
  _inherits(_default, _Component);
  return _createClass(_default, [{
    key: "onChange",
    value: function onChange(country, phone) {
      this.props.onChange("" + country + phone);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        _this$props$value = _this$props.value,
        value = _this$props$value === void 0 ? "49" : _this$props$value,
        formContext = _this$props.formContext,
        registry = _this$props.registry,
        rawErrors = _this$props.rawErrors,
        inputProps = _objectWithoutProperties(_this$props, _excluded2);
      var _splitValue = splitValue(value),
        _splitValue2 = _slicedToArray(_splitValue, 2),
        country = _splitValue2[0],
        phone = _splitValue2[1];
      return /*#__PURE__*/_jsx(PhoneControl, _objectSpread(_objectSpread({}, inputProps), {}, {
        country: country,
        phone: phone,
        onChange: function onChange(country, phone) {
          return _this.onChange(country, phone);
        }
      }));
    }
  }]);
}(Component);
export { _default as default };
//# sourceMappingURL=WhatsappPhoneWidget.js.map